__turbopack_context__.v({
  "cell_content": "TableMobileCell-module-scss-module__v-KagW__cell_content",
  "content_text": "TableMobileCell-module-scss-module__v-KagW__content_text",
  "header_image": "TableMobileCell-module-scss-module__v-KagW__header_image",
  "helper_text": "TableMobileCell-module-scss-module__v-KagW__helper_text",
  "helper_text_placeholder": "TableMobileCell-module-scss-module__v-KagW__helper_text_placeholder",
  "table_mobile_cell": "TableMobileCell-module-scss-module__v-KagW__table_mobile_cell",
  "title": "TableMobileCell-module-scss-module__v-KagW__title",
});
